import { IApplicationState } from '../../types/redux';

export const selectOpenedFilter = (state: IApplicationState) => {
  return state.filters.openedFilter;
};
